import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
  Typography,
  IconButton,
  Box
} from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Delete, Edit } from '@mui/icons-material';

import { getPermissions } from "../../commonFunctions/PermissionManger";
import {
  callAPI,
  getLocalValue,
  IRoleMain,
  LoacalVariables,
  MasterPages,
  Method
} from "../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import ConfirmationPopup from '../../Components/Confirmation/Confirmation';
import { Helmet } from 'react-helmet';
import { useAuth } from '../../StateManagement/authContext';

interface Leave {
  _id?: string;
  employeeId: string;
  leaveType: string;
  reason?: string;
  startDate: string;
  endDate: string;
  status?: string;
  createdAt?: string;
}

interface Employee {
  _id: string;
  name: string;
}

const LeaveRequestManager: React.FC = () => {
  const [leaves, setLeaves] = useState<Leave[]>([]);
  const [employees, setEmployees] = useState<Employee[]>([]);
  const [open, setOpen] = useState(false);
  const [selectedIdForDlt,setSelectedIdForDlt] = useState<any>(null);
  const [isPopupOpen,setPopupOpen] = useState(false);
  const [form, setForm] = useState<Leave>({
    employeeId: '',
    leaveType: 'casual',
    reason: '',
    startDate: '',
    endDate: '',
  });

  const {showMessage} = useSnackbar();
  const {user} = useAuth();

  const fetchLeaves = async () => {
    // const res = await axios.get('/api/leaves/getAll');
    // setLeaves(res.data.leaves);
  };

  const fetchEmployees = async () => {
    // const res = await axios.get('/api/employees/getAll');
    // setEmployees(res.data.employees);
  };

  const handleSave = async () => {
    try{
        const method = form._id ? Method.PUT : Method.POST;
              const url = form._id
                ? `leave/request/update${form._id}`
                : "leave/request/create";
        const data = form._id ? {status:form.status} : form;

              const response: any = await callAPI(url, method, data);
              if(response.success)
              {
                showMessage(response.message,"success");
              }
    }catch(error:any){

    }finally{
        setOpen(false);
        fetchLeaves();
    }
  };

  const handleStartDlt = (id: string) => {
    setPopupOpen(true);
    setSelectedIdForDlt(id);
  };

  const handleDelete = ()=>{
   fetchLeaves();
   setPopupOpen(false);
   setSelectedIdForDlt(null);
  }

  const handleEdit = (leave: Leave) => {
    setForm(leave);
    setOpen(true);
  };

  useEffect(() => {
    fetchLeaves();
    fetchEmployees();
  }, []);

  const columns: GridColDef[] = [
    { field: 'employeeName', headerName: 'Employee', flex: 1 },
    { field: 'leaveType', headerName: 'Type', flex: 1 },
    { field: 'startDate', headerName: 'Start Date', flex: 1 },
    { field: 'endDate', headerName: 'End Date', flex: 1 },
    { field: 'status', headerName: 'Status', flex: 1 },
    {
      field: 'actions',
      headerName: 'Actions',
      sortable: false,
      renderCell: (params) => (
        <>
          <IconButton onClick={() => handleEdit(params.row)}><Edit /></IconButton>
          <IconButton onClick={() => handleStartDlt(params.row._id)}><Delete /></IconButton>
        </>
      )
    }
  ];

  const rows = leaves.map((leave) => ({
    ...leave,
    employeeName: employees.find(e => e._id === leave.employeeId)?.name || 'Unknown'
  }));

  return (
    <>
    <Helmet>
            <title>Leave Request | Willsoar Technologies</title>
            <meta
              name="description"
              content="Start writing leave request, manage your leave request."
            />
          </Helmet>
    <Box p={2}>
      <Typography variant="h5" gutterBottom>Leave Requests</Typography>
      <Button variant="contained" sx={{
      backgroundColor: "#FF6B2C",
      textTransform: "none",
      "&:hover": { backgroundColor: "#e65c1d" }
    }}  onClick={() => { setForm({ employeeId: '', leaveType: 'casual', reason: '', startDate: '', endDate: '' }); setOpen(true); }}>New Leave</Button>
      <Box my={2}>
        <DataGrid rows={rows} columns={columns} autoHeight getRowId={(row) => row._id} />
      </Box>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{form._id ? 'Edit Leave Status' : 'New Leave Request'}</DialogTitle>
        <DialogContent>
          {/* {!form._id && (
            <TextField
              fullWidth
              select
              label="Employee"
              margin="dense"
              value={form.employeeId}
              onChange={(e) => setForm({ ...form, employeeId: e.target.value })}
            >
              {employees.map(emp => (
                <MenuItem key={emp._id} value={emp._id}>{emp.name}</MenuItem>
              ))}
            </TextField>
          )} */}

          <TextField
              fullWidth
              select
              label="Employee"
              margin="dense"
              defaultValue={getLocalValue(LoacalVariables.Name)}
            >
              
            </TextField>


          {!form._id && (
            <>
              <TextField
                fullWidth
                select
                label="Leave Type"
                margin="dense"
                value={form.leaveType}
                onChange={(e) => setForm({ ...form, leaveType: e.target.value })}
              >
                {['casual', 'sick', 'earned', 'unpaid', 'other'].map((type) => (
                  <MenuItem key={type} value={type}>{type}</MenuItem>
                ))}
              </TextField>

              <TextField
                fullWidth
                margin="dense"
                label="Reason"
                value={form.reason}
                onChange={(e) => setForm({ ...form, reason: e.target.value })}
              />

              <TextField
                fullWidth
                margin="dense"
                label="Start Date"
                type="date"
                value={form.startDate}
                onChange={(e) => setForm({ ...form, startDate: e.target.value })}
                InputLabelProps={{ shrink: true }}
              />

              <TextField
                fullWidth
                margin="dense"
                label="End Date"
                type="date"
                value={form.endDate}
                onChange={(e) => setForm({ ...form, endDate: e.target.value })}
                InputLabelProps={{ shrink: true }}
              />
            </>
          )}

          {form._id && (
            <TextField
              fullWidth
              select
              margin="dense"
              label="Status"
              value={form.status}
              onChange={(e) => setForm({ ...form, status: e.target.value })}
            >
              {['pending', 'approved', 'rejected'].map(s => (
                <MenuItem key={s} value={s}>{s}</MenuItem>
              ))}
            </TextField>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={handleSave} sx={{
      backgroundColor: "#FF6B2C",
      textTransform: "none",
      "&:hover": { backgroundColor: "#e65c1d" }
    }} variant="contained">Save</Button>
        </DialogActions>
      </Dialog>
    </Box>
    {isPopupOpen && (
              <ConfirmationPopup
                apiUrl={"leave/request/delete"}
                id={selectedIdForDlt}
                confirmMessage="Are you sure you want to delete this estimate?"
                open={isPopupOpen}
                onClose={() => setPopupOpen(false)}
                onConfirm={handleDelete}
                permanent
              />
            )}
    </>
  );
};

export default LeaveRequestManager;
